var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-holder"},[_c('ChartDoughnut',{staticClass:"pie",attrs:{"chart-data":_vm.chartData,"options":_vm.doughnutChartOptions,"width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }